angular.module('mychart').controller('GenericModalCtrl',
    ['$scope', '$uibModalInstance', '$window', '$sce', 'modalContent', 'canPrint',
        function ($scope, $modalInstance, $window, $sce, modalContent, canPrint) {
            'use strict';
            
            $scope.modalContent = $sce.trustAsHtml(modalContent);
            $scope.canPrint = canPrint;

            function ok() {
                $modalInstance.close('ok');
            }

            function cancel() {
                $modalInstance.dismiss('cancel');
            }

            function print() {
                $window.print();
            }

            $scope.print = print;
            $scope.ok = ok;
            $scope.cancel = cancel;
        }]);
